import React from 'react';

export default function Avatar({ user, size = 40, fontSize = 13 }) {
  const initials = user?.username?.slice(0, 2).toUpperCase() || '??';
  const avatarUrl = user?.avatar ? `https://social-agora.com${user.avatar}` : null;

  return avatarUrl ? (
    <img
      src={avatarUrl}
      alt={user.username}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '50%',
        objectFit: 'cover',
        flexShrink: 0,
        border: '2px solid var(--blue-border)'
      }}
    />
  ) : (
    <div style={{
      width: `${size}px`,
      height: `${size}px`,
      borderRadius: '50%',
      background: 'var(--blue-bg)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 700,
      fontSize: `${fontSize}px`,
      color: 'var(--blue)',
      flexShrink: 0
    }}>
      {initials}
    </div>
  );
}
